/**
 * @generated SignedSource<<7a60bbf210864d66dc1bda7eb443ba96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetVideoYoutubeIdVideo$data = {
  readonly videoSource: ReadonlyArray<{
    readonly id: string | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly youtubeId: string | null | undefined;
  readonly " $fragmentType": "helpersGetVideoYoutubeIdVideo";
};
export type helpersGetVideoYoutubeIdVideo$key = {
  readonly " $data"?: helpersGetVideoYoutubeIdVideo$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetVideoYoutubeIdVideo">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetVideoYoutubeIdVideo"
};

(node as any).hash = "a58c9cb3dbe3dc567f74e056e0450df4";

export default node;
